(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // customização: na home com header transparente, o sticky nativo (hide/reveal) é desligado
      this.isTransparentOnHome = this.classList.contains('header--transparent-on-home');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.isTransparentOnHome) return;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // customização: mede a barra de anúncio em TODAS as páginas.
  // Antes isso vivia dentro do init da home, então em outras páginas
  // --announcement-bar-height ficava 0 e a barra fixa cobria o header.
  function initAnnouncementBarHeight() {
    const setAnnouncementBarHeight = () => {
      const bar = document.querySelector('.announcement-bar-section');
      // Mede o conteúdo visível (.utility-bar); o wrapper da section pode ter altura 0 quando fixed
      const measureEl = bar ? bar.querySelector('.utility-bar') || bar : null;
      const height = measureEl ? measureEl.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', `${Math.ceil(height)}px`);
    };

    setAnnouncementBarHeight();
    requestAnimationFrame(setAnnouncementBarHeight);
    window.addEventListener('resize', setAnnouncementBarHeight);

    const bar = document.querySelector('.announcement-bar-section');
    if (bar && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setAnnouncementBarHeight).observe(bar.querySelector('.utility-bar') || bar);
    }
  }

  // customização: header transparente na home — branco sticky após o banner sair da viewport
  function initTransparentHeaderOnHome() {
    const headerWrapper = document.querySelector('.header--transparent-on-home');
    if (!headerWrapper) return;

    const firstSection = document.querySelector('#MainContent > .shopify-section');
    const hero = firstSection && firstSection.querySelector('.banner, slideshow-component');

    if (!hero) {
      headerWrapper.classList.add('header--scrolled');
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        headerWrapper.classList.toggle('header--scrolled', !entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(hero);
  }

  function initHeaderCustomizations() {
    initAnnouncementBarHeight();
    initTransparentHeaderOnHome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderCustomizations);
  } else {
    initHeaderCustomizations();
  }

  } catch(e) { console.error(e); }
})();
})();
